const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/utils/clientSetupManager.ts';
import _ from 'lodash';
import { buildClientSetupData } from '@cistec/common_web/services/clientSetupManager';
import { PatAppTheme, theme as themeCommonDef } from '../config/common/branding/theme';
import { createTheme } from '@mui/material/styles';
import { getMainConfigClient } from '@cistec/common_web/services/mainConfig';

//
// Initialize Client Setup Data
//
declare let require: any;

export const clientSetup = {
    administrationBySchemaTimes: {} as any,
};

buildClientSetupData(
    {
        administrationBySchemaTimes: { init: {}, type: 'overwrite' },
    },
    clientSetup,
    []
);

//
// Prepare Client Setup Data
//

const schemaTimes = _.compact(
    _.map(
        [
            { key: 'Mo', label: 'Morgens' },
            { key: 'Mi', label: 'Mittags' },
            { key: 'Ab', label: 'Abends' },
            { key: 'Na', label: 'Nachts' },
        ],
        (time: { key: string; label: string }) => {
            if (clientSetup.administrationBySchemaTimes[time.key]) {
                const splitTime = clientSetup.administrationBySchemaTimes[time.key].split(':');
                return { label: time.label, hours: parseInt(splitTime[0], 10), minutes: parseInt(splitTime[1], 10) };
            }
            return null;
        }
    )
);

let mockedSchemaTimes: any = null;
export const mockSchemaTimes = (mockedData: any) => (mockedSchemaTimes = mockedData);
export const unmockSchemaTimes = () => (mockedSchemaTimes = null as any);

export const getSchemaTimes = () => mockedSchemaTimes || schemaTimes; // make it mockable

/**
 * LOADING/ORGANISING client specific stuff
 * theme
 * */
const clientPath = getMainConfigClient(true);

const themeFiles: any[] = [];
export const loadThemeFile = (req: any) => (file: string) => {
    const res = req(file);
    themeFiles.push(res);
};

/**
 * webpack require: require. Context doesn't allow to be part of a function - it must not be inside anything,
 * the same is true for clientPath which can't be used inside require functions
 * require also doesn't allow to use any other variables than __APP__
 * therefore we break DRY
 * */
const themeFilenames = __APP__.SETTINGS.mimicksClient
    ? require.context(`../config/${__APP__.MIMICS_CLIENT_CONFIG_PATH}/branding/`, false, /theme.ts/)
    : require.context(`../config/${__APP__.CLIENT_CONFIG_PATH}/branding/`, false, /theme.ts/);
themeFilenames.keys().forEach(loadThemeFile(themeFilenames));

if (themeFilenames.keys().length > 1) {
    throw new Error(
        `'got more than one theme-files in client setup - this is impossible: ${
            __APP__.SETTINGS.mimicksClient ? __APP__.MIMICS_CLIENT_CONFIG_PATH : __APP__.CLIENT_CONFIG_PATH
        } `
    );
}

let newTheme: any = themeCommonDef;
if (themeFiles[0]) {
    newTheme = _.merge(themeCommonDef, themeFiles[0].theme);
}

export const theme: PatAppTheme = createTheme(newTheme);

/**
 * LOADING/ORGANISING client specific stuff
 * image-Filenames
 * */
const ImageFileNamesCommon = require.context(`../config/common/branding/images`, false, /\w+\.(png)|(jpg)|(svg)/);

const ImageFileNamesClient = __APP__.SETTINGS.mimicksClient
    ? require.context(`../config/${__APP__.MIMICS_CLIENT_CONFIG_PATH}/branding/images`, false, /\w+\.(png)|(jpg)|(svg)/)
    : require.context(`../config/${__APP__.CLIENT_CONFIG_PATH}/branding/images`, false, /\w+\.(png)|(jpg)|(svg)/);

const imageFileNamesFinal: string[] = [];

const indexes: number[] = [];
const rmExt = (fileName: string) => {
    return fileName?.split('/')?.slice(-1).join()?.split('.').shift();
};

const addPath = (path: string) => (fileName: string) => {
    return path + '/' + fileName?.split('/').slice(-1).join();
};
const imgPathCl = addPath(`./img/${clientPath}`);
const imgPathCm = addPath(`./img/common`);

// merge ImageFileNamesCommon and ImageFileNamesClient
// you can use additional images only for client
ImageFileNamesCommon.keys().forEach((cmn: string) => {
    const ix = ImageFileNamesClient.keys().findIndex((cl: string) => rmExt(cl) === rmExt(cmn));
    if (ix !== -1) {
        imageFileNamesFinal.push(imgPathCl(ImageFileNamesClient.keys()[ix]));
        indexes.push(ix);
    } else {
        imageFileNamesFinal.push(imgPathCm(cmn));
    }
});

// add client ones which don't exist in common
ImageFileNamesClient.keys().forEach((cl: string, ix: number) => {
    if (!indexes.findIndex(i => i === ix)) {
        imageFileNamesFinal.push(imgPathCl(cl));
    }
});
export const getImageFileName = (fileName: string) => {
    if (fileName.match(/\./)) {
        throw Error(`clientSetupManager:getImageFileName: dont pass any file-extension. you did pass: ${fileName}`);
    }
    return imageFileNamesFinal.find(f => rmExt(f) === fileName);
};
